var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height"},[_c('app-nav',{attrs:{"mini":_vm.mini},on:{"navToggle":_vm.navToggle}}),_c('top-menu',{on:{"navToggle":_vm.navToggle}}),_c('v-content',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }